export const manifest = {
  screens: {
    scr_ttmij5: { name: "Landing", route: "/", position: {"x":160,"y":220} },
    scr_zbqzh1: { name: "Checkout", route: "/checkout", position: {"x":1560,"y":220} },
  },
  sections: {
    sec_ye5gx6: { name: "Main user flow", x: 0, y: 0, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_ye5gx6", children: [
      { kind: "screen", id: "scr_ttmij5" },
      { kind: "screen", id: "scr_zbqzh1" },
    ] },
  ],
}
